/**
 * 判断值是否为数组
 * @return 是否为数组
 */
export default function isArray(value) {
    return Array.isArray(value);
}
//# sourceMappingURL=is-array.js.map